import {
  Flex,
  Heading,
  Link,
  Paragraph,
  Stack,
} from '@beamery/lib-ds-components';
import type {
  Element,
  Text as TextElement,
} from '@beamery/component-rich-text';
import { DisplayRichText } from '@beamery/component-rich-text';
import styled from 'styled-components';
import { useMemo } from 'react';
import { useTranslation } from '../../../../hooks/use-translation';
import type { ComplianceProps } from './compliance.interface';
import { DataProtectionField } from './data-protection-field';

const Container = styled(Flex)`
  gap: ${({ theme }) => theme.space.x1};
  position: relative;
`;
Container.defaultProps = {
  direction: 'column',
};

export const ComplianceV2 = ({
  fieldName,
  compliance,
  fieldValidationRules,
  control,
}: ComplianceProps) => {
  const { t } = useTranslation();
  const introductionStatement = useMemo(
    () =>
      JSON.parse(compliance.consentRequestIntroductionStatement) as (
        | Element
        | TextElement
      )[],
    [compliance.consentRequestIntroductionStatement],
  );

  return (
    <Container>
      {compliance.title && <Heading variant='2'>{compliance.title}</Heading>}
      <Stack gapBetweenChildren='x4'>
        <div>
          <DisplayRichText content={introductionStatement} />

          <DataProtectionField
            control={control}
            fieldName={fieldName}
            fieldValidationRules={fieldValidationRules}
            label={compliance.consentQuestion}
          />
        </div>

        <Paragraph>
          <Link
            setting='inline'
            variant='emphasised'
            href={compliance.privacyPolicyUrl}
          >
            {compliance.privacyPolicyText || t('compliance.privacy-policy')}
          </Link>
        </Paragraph>
      </Stack>
    </Container>
  );
};
